import React from 'react';
import { Empty, Card, Space } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { Notice } from '../../components/common/Notice';

// Phase 5 - US3: Contractor Reports (Coming Soon)

const ContractorReports: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Relatórios</h1>
        <p className="mt-2 text-gray-600">
          Acompanhe o progresso de coleta de respostas e estatísticas detalhadas das suas pesquisas
        </p>
      </div>

      {/* Alert - Coming Soon */}
      <div className="mb-8">
        <Notice
          message="Funcionalidade em Breve"
          description="Os relatórios estarão disponíveis em breve. Esta funcionalidade permitirá que você acompanhe o progresso de cada pesquisa, estatísticas de resposta e análises detalhadas."
          type="info"
          icon={<ClockCircleOutlined style={{ color: '#2E2B81', fontSize: 14, marginTop: 1 }} />}
          showIcon
          closable
        />
      </div>

      {/* Empty State */}
      <Card className="shadow-md">
        <Empty
          image={
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="80" height="80" rx="4" fill="#f5f5f5" />
              <path
                d="M20 40C20 28.954 28.954 20 40 20C51.046 20 60 28.954 60 40C60 51.046 51.046 60 40 60C28.954 60 20 51.046 20 40ZM40 26C32.268 26 26 32.268 26 40C26 47.732 32.268 54 40 54C47.732 54 54 47.732 54 40C54 32.268 47.732 26 40 26Z"
                fill="#d9d9d9"
              />
              <path
                d="M40 34C39.448 34 39 34.448 39 35V40C39 40.552 39.448 41 40 41H45C45.552 41 46 40.552 46 40C46 39.448 45.552 39 45 39H41V35C41 34.448 40.552 34 40 34Z"
                fill="#d9d9d9"
              />
            </svg>
          }
          description={
            <Space direction="vertical" style={{ textAlign: 'center' }}>
              <p style={{ color: '#8c8c8c', marginBottom: 0 }}>
                Relatórios serão disponibilizados em breve
              </p>
              <p style={{ color: '#bfbfbf', fontSize: '12px', marginTop: 8 }}>
                Aguarde atualizações futuras para começar a analisar seus dados
              </p>
            </Space>
          }
        />
      </Card>
    </div>
  );
};

export default ContractorReports;
